import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,
  Button,Swiper,Ellipsis,Image,Grid,NavBar,Tabs,Avatar,Tag,SearchBar,List,Modal,Toast,Badge
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, SetOutline,RightOutline } from 'antd-mobile-icons'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import { environment } from '../../service/baseUrl';

import {
    GetUserInfoByOpenId,GetWXUserByOpenId,GetPlanets,PostUserActions,Posts,GetPublicAccountFollowerByOpenId,CreatePublicAccountFollower
} from '../../service/service';
import { useNavigate } from 'react-router-dom';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            fileList: [],
            planet: [],
            userInfo: null,

            myPostCount: 0,
            myPostSCCount: 0,
            myPostGTCount: 0,

        };
    }

    componentDidMount() {
        var that = this;
        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            GetWXUserByOpenId().then(res => {
                if (res.success) {
                    if (res.result.headImg != null && res.result.headImg != "") {
                        
                        if (res.result.headImg.indexOf("https://") > -1) {
                            var urls = res.result.headImg.split("https://").filter(Boolean);
                            res.result.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                        } else {
                            res.result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + res.result.headImg;
                        }
                        
                    }
                    localStorage.setItem("user", JSON.stringify(res.result))
                    that.setState({
                        userInfo: res.result
                    })
                }
            })

        } else {
            this.setState({
                userInfo: JSON.parse(user)
            })
        }
        

        GetPlanets().then(res => {
            if (res.success) {
                res.result.map(item => {
                    //item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                    if (item.headImg != null) {
                        if (item.headImg.indexOf("https://") > -1) {
                            var urls = item.headImg.split("https://").filter(Boolean);
                            item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                        } else {
                            item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        }
                    }
                })
                that.setState({
                    planet: res.result
                })
            }
        })

        PostUserActions().then(res => {
            if (res.success) {
                var items = res.result.filter(x => x.type == 3);

                var field = 'tableId';
                const getUniqueData = () => {
                  return [...new Map(res.result.map(item => [item[field], item])).values()];
                };

                that.setState({
                    myPostSCCount: items.length,
                    myPostGTCount: getUniqueData().length,
                })
            }
        })

        Posts({
            OpenId: localStorage.getItem("openid"),
            MaxResultCount: 9999,
        }).then(res => {
            if (res.success) {
                that.setState({
                    myPostCount: res.result.totalCount,
                })
            }
        })

        

        var state = true;
        var closeFollow = localStorage.getItem("closeFollow");
        if (closeFollow != undefined) {
            closeFollow = new Date(closeFollow);
            closeFollow.setMinutes(closeFollow.getMinutes() + 5);
            if (new Date() < closeFollow) {
                state = false;
            } else {
                localStorage.setItem("closeFollow", new Date());
            }
        }

        if (state && false) {
            GetPublicAccountFollowerByOpenId("NNXC").then(res => {
                if (res.success) {
                    if (!res.result) {
                        Modal.show({
                            content:
                                <>
                                    <div style={{ marginTop: "3%" }}>
                                        <Avatar src='https://api.weibinyi.com/images/niannian/nnerweima.jpg'
                                            style={{ '--size': '55px', '--border-radius': '35px', 'margin': 'auto' }} />
                                        <div style={{ textAlign: "center", marginTop: "4%" }}>
                                            念念星辰
                                            </div>
                                    </div>
                                    <div style={{ textAlign: "center", marginTop: "9%", textDecoration: "underline" }}>
                                        <a href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzOTA2OTIyMA==#wechat_redirect"
                                            style={{ color: "#0538ff" }}
                                            onClick={(e) => {
                                                e.preventDefault(); // 阻止默认跳转行为
                                                // 添加其他需要处理的JS代码
                                                CreatePublicAccountFollower({}).then(res => {
                                                    // 处理完成后执行跳转
                                                    window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzOTA2OTIyMA==#wechat_redirect";
                                                })
                                            }}>
                                            关注公众号</a>
                                    </div>
                                    {/* <div style={{ textAlign: "center", marginTop: "4%", textDecoration: "underline", color: "#0538ff" }}>
                                        <span onClick={() => {
                                            localStorage.setItem("follow", true);
                                            Modal.clear();
                                        }}>已关注</span>
                                    </div> */}
                                </>,
                            closeOnMaskClick: true,
                            actions: [],
                            bodyStyle: {
                                width: '85%',  // 设置为屏幕宽度的70%
                                margin: '0 auto', // 水平居中
                                maxWidth: '300px' // 可选：设置最大宽度
                            },
                            afterClose: () => {
                                localStorage.setItem("closeFollow", new Date());
                            },
                        })
                    }
                }
            })

        }
    }

    getUserInfo() {
        var openid = localStorage.getItem("openid");
        if (openid == null || openid == undefined) {
            Toast.show({
                icon: 'error',
                content: '系统异常，请重新进入！',
            })
            setTimeout(() => {
                window.location.href = environment.wxredirecturi;
            }, 2000);
            return;
        }

        this.props.navigate('/userEdit', { replace: true }); // 传递状态
        // GetUserInfoByOpenId().then(res => {
        // })
    }

    getUserPhone() {
        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            Toast.show({
              content: '请先点击获取头像',
              afterClose: () => {
                console.log('after')
              },
            })
            return;
        }

        Modal.show({
            title: '绑定手机号',
            content: 
                <>
                    <Form
                        name='form'
                        onFinish={this.onFinish}
                        layout='horizontal'
                        footer={
                            <Button block type='submit' shape='rounded'
                                style={{ color: "#000", width: "50%", backgroundColor: "#d8ff01", margin: "auto" }}
                                color='primary'>
                                提交
                            </Button>
                        }
                    >
                        <Form.Item
                            name='phone'
                            label='手机号'
                            rules={[{ required: true, message: '手机号不能为空' }]}
                        >
                            <Input onChange={console.log} placeholder='请输入手机号' />
                        </Form.Item>

                    </Form>
                </>,
            closeOnMaskClick: true,
        })

    }

    onFinish = (values) => {
        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            Toast.show({
              content: '请先点击获取头像',
              afterClose: () => {
                console.log('after')
              },
            })
            return;
        }
        if (values.phone.length !== 11) {
            Toast.show({
              content: '请输入正确的手机号',
              afterClose: () => {
                console.log('after')
              },
            })
            return;
        }

        user = JSON.parse(user);
        user.phone = values.phone;
        user.displayPhone = values.phone.slice(0, 3) + '****' + values.phone.slice(7);

        this.setState({
            userInfo: user
        })

        localStorage.setItem("user", JSON.stringify(user));
        
        Modal.clear();
    }

    submitForm = () => {
        
    }
    


    render() {

        return (
            <div style={{
                height: "100%", width: "100%", overflow: "auto",
                backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/11-06.png')"
                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%"
            }}>
                
                <div style={{ marginTop: "6%" }}>
                    <Grid columns={4} gap={8}>
                        <Grid.Item span={1}>
                            <div style={{ margin: "12px 0px 6px 20px" }}>
                                <Avatar src={
                                    (this.state.userInfo == undefined || this.state.userInfo.headImg == undefined) ?
                                        "" : this.state.userInfo.headImg}
                                    style={{ '--size': '48px', '--border-radius': '35px', 'margin': 'auto' }} />
                            </div>
                        </Grid.Item>
                        <Grid.Item span={2}>
                            <div style={{ height: "100%", paddingTop: "5%" }}>
                                {
                                    (this.state.userInfo == null || this.state.userInfo == undefined
                                        || this.state.userInfo.nickName == "获取头像") ?
                                        <div style={{
                                            fontSize: "16px", fontWeight: "600",
                                            color: "#000", textDecoration: "underline"
                                        }} onClick={() => {
                                            this.getUserInfo();
                                        }}>微信用户</div>
                                        :
                                        <div style={{ fontSize: "16px", fontWeight: "600" }}>{this.state.userInfo.nickName}</div>
                                }
                                {
                                    (this.state.userInfo == null || this.state.userInfo == undefined) ?
                                        <div style={{ color: "#000", textDecoration: "underline", marginTop: "3px" }}
                                            onClick={() => {
                                                // this.getUserPhone();
                                                window.location.href = environment.wxredirecturi;
                                            }}>用户登录</div>
                                        :
                                        <div style={{
                                            color: "#000", marginTop: "3px",
                                            textDecoration: ((this.state.userInfo.phone || "绑定手机号") == "绑定手机号") ?
                                                "underline" : "none"
                                        }}
                                            onClick={() => {
                                                if ((this.state.userInfo.phone || "绑定手机号") == "绑定手机号") {
                                                    this.props.navigate('/userEdit', { replace: true })
                                                }
                                            }}>
                                            {this.state.userInfo.phone || "绑定手机号"}
                                        </div>
                                }
                            </div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                            
                        </Grid.Item>
                    </Grid>
                </div>

                <div style={{
                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/1/11-13.png')"
                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", width: "92%", marginLeft: "4%",
                    padding: "10px 0px 10px 15px", marginTop: "10px", color: "#fff"
                }}>
                    <div>
                        <Image
                            src={"https://api.weibinyi.com/images/niannian/1/11-08.png"}
                            width={15}
                            height={15}
                            fit='cover'
                            style={{
                                display: "inline-flex", marginTop: "4px", marginLeft: "3px"
                            }}
                        />
                        <span style={{ fontSize: "14px", marginLeft: "10px" }}>升级星球</span>
                    </div>
                    <div>
                        超大存储、双倍增币、尊享权益
</div>
                </div>


                <div style={{
                    width: "92%", marginLeft: "4%", borderRadius: "7px",
                    padding: "7px 0px 10px 4px", marginTop: "10px", backgroundColor: "#fff"
                }}>
                    <Grid columns={7} gap={8}>
                        <Grid.Item span={1}>
                            <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                            ❋
</div>
                            <div style={{ marginTop: "-3px", textAlign: "center" }}>
                                关注
</div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                            <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                            ❋
</div>
                            <div style={{ marginTop: "-3px", textAlign: "center" }}>
                                粉丝
</div>

                        </Grid.Item>

                        <Grid.Item span={5} style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end" // 新增
                        }}>
                            <div style={{
                                display: "flex",
                                width: "100%",
                                placeItems: "center",
                                marginRight: "8px",
                                justifyContent: "space-between" // 替代固定宽度
                            }}>
                                <div style={{
                                    position: "relative",
                                    flex: 0.45,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <Image
                                        src="https://api.weibinyi.com/images/niannian/1/11-09.png"
                                        style={{
                                            width: "100%",
                                            height: "90%",
                                            maxWidth: 100
                                        }}
                                        onClick={() => this.props.navigate('/userEdit', { replace: true })}
                                    />
                                    <span style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        fontSize: 12,
                                        whiteSpace: "nowrap"
                                    }} onClick={() => this.props.navigate('/userEdit', { replace: true })}>
                                        编辑资料
          </span>
                                </div>

                                <div style={{ flex: 0.25 }}>
                                    <Badge content="99+" style={{ marginTop: "8px" }}>
                                        <Image
                                            src="https://api.weibinyi.com/images/niannian/1/11-10.png"
                                            style={{
                                                width: "100%",
                                                height: "90%",
                                                marginTop: "5px"
                                            }}
                                        />
                                    </Badge>
                                </div>

                                <div style={{ flex: 0.25 }}>
                                    <Image
                                        src="https://api.weibinyi.com/images/niannian/1/11-11.png"
                                        style={{
                                            width: "100%",
                                            height: "90%",
                                        }}
                                        onClick={() => this.props.navigate('/seting', { replace: true })}
                                    />
                                </div>
                            </div>
                        </Grid.Item>
                    
                    </Grid>
                
                </div>


                <div style={{
                    width: "92%", marginLeft: "4%", borderRadius: "7px",
                    padding: "7px 0px 10px 4px", marginTop: "10px", backgroundColor: "#fff"
                }}>
                    <div style={{ fontSize: "16px", fontWeight: "600", marginLeft: "10px" }}>
                        帖子
                    </div>
                    <div style={{ width: "92%", margin: "2px 0px 2px 3%" }}>
                        <Grid columns={6} gap={8}>
                            <Grid.Item span={2}>
                                <span style={{ fontSize: "16px", fontWeight: "500", marginRight: "6px" }}>
                                    {this.state.myPostCount}
                                </span>
                                <span style={{ color: "#838383" }}>我的发帖</span>
                            </Grid.Item>
                            <Grid.Item span={2} style={{ textAlign: "center" }}>
                                <span style={{ fontSize: "16px", fontWeight: "500", marginRight: "6px" }}>
                                    {this.state.myPostSCCount}
                                </span>
                                <span style={{ color: "#838383" }}>收藏</span>
                            </Grid.Item>
                            <Grid.Item span={2} style={{ textAlign: "end" }}>
                                <span style={{ fontSize: "16px", fontWeight: "500", marginRight: "6px" }}>
                                    {this.state.myPostGTCount}
                                </span>
                                <span style={{ color: "#838383" }}>跟帖</span>
                            </Grid.Item>
                        </Grid>
                    </div>
                </div>


                <div style={{
                    width: "92%", marginLeft: "4%", borderRadius: "7px",
                    padding: "7px 0px 10px 4px", marginTop: "10px", backgroundColor: "#fff"
                }}>
                    <div style={{ fontSize: "16px", fontWeight: "600", marginLeft: "10px", marginBottom: "10px" }}>
                        星球关系
    </div>
                    <div style={{ marginTop: "5px" }}>
                        <Grid columns={6} gap={8}>
                            {
                                this.state.planet.map(item=>{
                                    return (<Grid.Item span={1}>
                                        <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}
                                            onClick={() => {
                                                this.props.navigate('/planetUser?planetId=' + item.id, { replace: true, state: { id: item.id } }); // 传递状态
                                            }}>
                                            <Image
                                                src={item.headImg == null ? "https://api.weibinyi.com/images/niannian/thtx.jpg" : item.headImg}
                                                width={18}
                                                height={18}
                                                fit='cover'
                                                style={{
                                                    display: "inline-flex"
                                                }}
                                            />
                                        </div>
                                        <div style={{ marginTop: "-3px", textAlign: "center" }}
                                            onClick={() => {
                                                this.props.navigate('/planetUser?planetId=' + item.id, { replace: true, state: { id: item.id } }); // 传递状态
                                            }}>
                                            {item.name}
                                        </div>
                                    </Grid.Item>)
                                })
                            }
                            {
                                this.state.planet.length == 0 ?
                                    <Grid.Item span={6}>
                                        <div style={{ textAlign: "center", fontSize: "14px", marginBottom: "10px" }}>
                                            暂无相关数据
                                        </div>
                                    </Grid.Item> : null
                            }
                        </Grid>
                    </div>
                </div>


                <div style={{
                    width: "92%", marginLeft: "4%", borderRadius: "7px",
                    padding: "7px 0px 10px 4px", marginTop: "10px", backgroundColor: "#fff"
                }}>
                    <div style={{ fontSize: "16px", fontWeight: "600", marginLeft: "10px" }}>
                        我的
</div>
                    <div style={{ margin: "10px 0px 8px 0px" }}>
                        <Grid columns={4} gap={8}>
                            <Grid.Item span={1}>
                                <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                                    <Image
                                        src={"https://api.weibinyi.com/images/niannian/1/11-20.png"}
                                        width={55}
                                        height={35}
                                        fit='cover'
                                        style={{
                                            display: "inline-flex"
                                        }} onClick={() => {
                                            this.props.navigate('/myPosts', { replace: true }); // 传递状态
                                        }}
                                    />
                                </div>
                                <div style={{ marginTop: "-3px", textAlign: "center" }}>
                                    <span onClick={() => {
                                        this.props.navigate('/myPosts', { replace: true }); // 传递状态
                                    }}>
                                        我的发帖
                                    </span>
</div>
                            </Grid.Item>
                            <Grid.Item span={1}>
                                <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                                    <Image
                                        src={"https://api.weibinyi.com/images/niannian/1/11-21.png"}
                                        width={55}
                                        height={35}
                                        fit='cover'
                                        style={{
                                            display: "inline-flex"
                                        }} onClick={() => {
                                            this.props.navigate('/shoppingCart', { replace: true, state: { from: 'home' } }); // 传递状态
                                        }}
                                    />
                                </div>
                                <div style={{ marginTop: "-3px", textAlign: "center" }}>
                                    <span onClick={() => {
                                        this.props.navigate('/shoppingCart', { replace: true, state: { from: 'home' } }); // 传递状态
                                    }}>
                                        我的订单
                                    </span>
</div>
                            </Grid.Item>
                            <Grid.Item span={1}>
                                <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                                    <Image
                                        src={"https://api.weibinyi.com/images/niannian/1/11-22.png"}
                                        width={55}
                                        height={35}
                                        fit='cover'
                                        style={{
                                            display: "inline-flex"
                                        }} onClick={() => {
                                            Modal.show({
                                                content:
                                                    <>
                                                        <div style={{ marginTop: "3%" }}>
                                                            <Avatar src='https://api.weibinyi.com/images/niannian/nnerweima.jpg'
                                                                style={{ '--size': '250px', 'margin': 'auto' }} />
                                                            <div style={{ textAlign: "center", marginTop: "4%" }}>
                                                                长按识别二维码
                                            </div>
                                                        </div>
                                                    </>,
                                                closeOnMaskClick: true,
                                                actions: [],
                                                bodyStyle: {
                                                    width: '100%',  // 设置为屏幕宽度的70%
                                                    margin: '0 auto', // 水平居中
                                                    // maxWidth: '300px' // 可选：设置最大宽度
                                                },
                                                afterClose: () => {
                                                    localStorage.setItem("closeFollow", new Date());
                                                },
                                            })
                                        }}
                                    />
                                </div>
                                <div style={{ marginTop: "-3px", textAlign: "center" }}>
                                    <span onClick={() => {
                                        
                                        Modal.show({
                                            content:
                                                <>
                                                    <div style={{ marginTop: "3%" }}>
                                                        <Avatar src='https://api.weibinyi.com/images/niannian/nnerweima.jpg'
                                                            style={{ '--size': '250px', 'margin': 'auto' }} />
                                                        <div style={{ textAlign: "center", marginTop: "4%" }}>
                                                            长按识别二维码
                                            </div>
                                                    </div>
                                                </>,
                                            closeOnMaskClick: true,
                                            actions: [],
                                            bodyStyle: {
                                                width: '100%',  // 设置为屏幕宽度的70%
                                                margin: '0 auto', // 水平居中
                                                // maxWidth: '300px' // 可选：设置最大宽度
                                            },
                                            afterClose: () => {
                                                localStorage.setItem("closeFollow", new Date());
                                            },
                                        })
                                        // window.location.href =
                                        //     "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzOTA2OTIyMA==#wechat_redirect"
                                    }}>
                                        联系客服
                                    </span>
                                </div>

                            </Grid.Item>
                            <Grid.Item span={1}>
                                <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}>
                                    <Image
                                        src={"https://api.weibinyi.com/images/niannian/1/11-23.png"}
                                        width={55}
                                        height={35}
                                        fit='cover'
                                        style={{
                                            display: "inline-flex"
                                        }} onClick={() => {
                                            localStorage.clear();
                                            this.props.navigate('/index', { replace: true, state: { from: 'home' } }); // 传递状态
                                        }}
                                    />
                                </div>
                                <div style={{ marginTop: "-3px", textAlign: "center" }}>
                                    <span onClick={() => {
                                        localStorage.clear();
                                        this.props.navigate('/index', { replace: true, state: { from: 'home' } }); // 传递状态
                                    }}>退出登录</span>
</div>

                            </Grid.Item>
                        </Grid>
                    </div>
                </div>


                <BottomMenu  position="absolute" selectKey="my" />

            </div>
        )
    }
}

export default withNavigate(Index);